import { Pagination } from '@malesia/react-components/dist/src/components/Pagination';
import { TableFooter } from '@malesia/react-components/dist/src/components/Table/TableFooter';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectList, selectPagination } from '../store/selectors';
import { balanceLogActions } from '../store/slice';

export const AccountingBalanceLogFooterWithStore: SFC = () => {
    const dispatch = useDispatch();
    const list = useSelector(selectList);
    const pagination = useSelector(selectPagination);

    return (
        <TableFooter
            paginationSlot={
                <Pagination
                    total={list.total}
                    pageTotal={list.items.length}
                    pagination={pagination}
                    maxPageSize={50}
                    setPage={(data) => {
                        dispatch(balanceLogActions.setPage(data));
                    }}
                    setPageSize={(data) => {
                        dispatch(balanceLogActions.setPageSize(data));
                    }}
                />
            }
        />
    );
};
